import React from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import style from 'assets/jss/material-dashboard-pro-react/components/customLoadingIndicatorStyle';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(style);

interface ILoadingIndicatorProps {
	loadingIndicatorVisible: boolean;
}

const CustomLoadingIndicator = ({ loadingIndicatorVisible }: ILoadingIndicatorProps) => {
	const classes = useStyles();

	const linearProgressClasses = classnames({
		[classes.loadingIndicator]: true,
	});

	return <div className={linearProgressClasses}>{loadingIndicatorVisible && <LinearProgress />}</div>;
};

const mapStateToProps = (state: types.redux.rootReducer) => ({
	loadingIndicatorVisible: state.api.loadingIndicator.loadingIndicatorVisible,
});

export default connect(mapStateToProps)(CustomLoadingIndicator);
